import { Controller } from "@hotwired/stimulus"

declare function gtag(...args: unknown[]): void

export default class AnalyticsController extends Controller {
  static values = { event: String }

  declare eventValue: string

  track(): void {
    if (typeof gtag === "undefined") return
    gtag("event", this.eventValue)
  }
}
